export default "__VITE_ASSET__rogwNgPR__"